export default "__VITE_ASSET__DglXk$4u__$_?no-inline__"